<template>
  <div class="kpb-lead">
    <slot name="top" />
    <Lead v-bind="{ ...data, ...options }">
      <template #title>
        <slot name="title" />
      </template>
    </Lead>
    <slot name="bottom" />
  </div>
</template>

<script>
/** Component for kvass lead */
import Lead from '@kvass/lead'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Lead,
  },
}
</script>
